<template>
  <div
    v-if="wineMakingNotes.length > 0 || tastingNotes.length > 0"
    class="winemaking-notes-section"
  >
    <b-container>
      <b-row>
        <b-col>
          <section>
            <section
              v-if="wineMakingNotes.length > 0"
              class="mb-3"
            >
              <h2>Notes</h2>
              <wine-making-notes-component
                :content="wineMakingNotes"
                map="winemaking"
              />
            </section>
            <section
              v-if="tastingNotes.length > 0"
              class="mb-3"
            >
              <h2 class="mt-3">Tasting Notes</h2>
              <wine-making-notes-component
                :content="tastingNotes"
                map="tasting"
              />
            </section>
          </section>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import WineMakingNotesComponent from './WineMakingNotesComponent.vue'

export default {
  name: 'wine-making-notes',
  components: {
    'wine-making-notes-component': WineMakingNotesComponent
  },
  props: {
    wineMakingNotes: {
      type: [Object, Array],
      required: true
    },
    tastingNotes: {
      type: [Object, Array],
      required: true
    }
  }
}
</script>
